import { render, staticRenderFns } from "./book-preview.vue?vue&type=template&id=7e048c66"
import script from "./book-preview.vue?vue&type=script&lang=js"
export * from "./book-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports